import React from 'react'
import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { labravDefaultThemeV7 as theme } from '@labrav/react-components'

type SubscriptionDetailHeadingClasses = {
  sectionHeadingIconWrap: string
}

export function renderSubscriptionDetailHeadingIcon(
  classes: SubscriptionDetailHeadingClasses
): React.ReactElement {
  return (
    <div className={classes.sectionHeadingIconWrap}>
      <FontAwesomeIcon
        icon={faListUl}
        style={{ width: theme.spacing(1.75), height: theme.spacing(1.75) }}
      />
    </div>
  )
}
